import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

const ExcelChart = () => {
  const [selectedFile, setSelectedFile] = useState(""); 
  const [data, setData] = useState([]);
  
  const files = [
    "NDVI.xlsx",
    "GCI.xlsx",
    "GNDVI.xlsx",
    "NDRE.xlsx",
    "FRUITS.xlsx"
  ];

  useEffect(() => {
    if (selectedFile) {
      fetch(`/${selectedFile}`) // ❌ Estaba fetch`/${selectedFile}` - error de sintaxis
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader();
          reader.readAsBinaryString(blob);
          reader.onload = (e) => {
            const workbook = XLSX.read(e.target.result, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet);
            
            if (jsonData.length > 0) {
              const keys = Object.keys(jsonData[0]).filter(key => key !== "Week");
              const formattedData = jsonData.map((row) => {
                let newRow = { Week: row.Week }; // ✅ Cambiado de Day a Week
                keys.forEach((key) => {
                  newRow[key] = parseFloat(row[key]) || 0;
                });
                return newRow;
              });
              setData(formattedData);
            }
          };
        })
        .catch(error => console.error("Error loading file:", error));
    }
  }, [selectedFile]);

  return (
    <div className="max-w-6xl mx-auto p-6"> {/* ❌ Estaba max-w-6xl sin className */}
      <h2 className="text-3xl font-bold text-center mb-6 text-gray-800 flex items-center justify-center gap-2">
        <FontAwesomeIcon icon={faChartLine} className="text-primary text-4xl" />
        Visualización de datos de sensores
      </h2>

      <div className="flex flex-col items-center mb-8">
        <label className="mb-2 text-lg text-gray-700 font-medium">
          <FontAwesomeIcon icon={faFileExcel} className="mr-2 text-green-600" />
          Selecciona un archivo:
        </label>
        <select
          className="w-full md:w-1/3 p-2 border border-gray-300 rounded shadow-sm focus:outline-none focus:ring focus:border-blue-400"
          onChange={(e) => setSelectedFile(e.target.value)}
          value={selectedFile}
        >
          <option value="">-- Elegir archivo --</option>
          {files.map((file, index) => (
            <option key={index} value={file}>
              📄 {file}
            </option>
          ))}
        </select>
      </div>

      {data.length > 0 && (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis 
              dataKey="Week" 
              label={{ value: 'Semana', position: 'insideBottom', offset: -5 }}
            />
            <YAxis 
              label={{ value: 'Valor', angle: -90, position: 'insideLeft' }}
            />
            <Tooltip />
            <Legend />
            {Object.keys(data[0])
              .filter(key => key !== "Week")
              .map((key, index) => (
                <Line 
                  key={index} 
                  type="monotone" 
                  dataKey={key} 
                  stroke={`hsl(${index * 60}, 70%, 50%)`} // ❌ Estaba stroke=`hsl...` sin {}
                  strokeWidth={2}
                  dot={{ r: 3 }}
                />
              ))
            }
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default ExcelChart;
